import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import { toast } from "sonner";

import { CartProvider, useCart } from "./lib/cart-context";
import Navbar from "./sections/Navbar";
import Hero from "./sections/Hero";
import Marquee from "./sections/Marquee";
import About from "./sections/About";
import Shop from "./sections/Shop";
import Boba from "./sections/Boba";
import Visit from "./sections/Visit";
import Footer from "./sections/Footer";
import CartDrawer from "./sections/CartDrawer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function PaymentStatusWatcher() {
  const { clear } = useCart();

  useEffect(() => {
    const url = new URL(window.location.href);
    const linkKey = url.searchParams.get("square_link");
    const canceled = url.searchParams.get("canceled");

    if (canceled) {
      toast.info("Checkout canceled. Your cart is still here.");
      url.searchParams.delete("canceled");
      window.history.replaceState({}, "", url.toString());
      return;
    }

    if (!linkKey) return;

    let attempts = 0;
    const maxAttempts = 10;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/checkout/status/${linkKey}`);
        const ps = (data.payment_status || "").toUpperCase();
        const st = (data.status || "").toUpperCase();
        if (ps === "COMPLETED" || ps === "APPROVED" || st === "COMPLETED") {
          toast.success("Payment successful! Thanks for supporting the dojo. 🥷");
          clear();
          url.searchParams.delete("square_link");
          window.history.replaceState({}, "", url.toString());
          return;
        }
        if (st === "CANCELED" || ps === "FAILED" || ps === "CANCELED") {
          toast.error("Payment was not completed.");
          url.searchParams.delete("square_link");
          window.history.replaceState({}, "", url.toString());
          return;
        }
        if (attempts < maxAttempts) {
          setTimeout(poll, 2000);
        } else {
          toast.message("Still processing — check your email for confirmation.");
        }
      } catch (e) {
        console.error(e);
        if (attempts < maxAttempts) setTimeout(poll, 2000);
      }
    };
    toast.message("Checking payment status...");
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

function Home() {
  return (
    <div data-testid="home-page" className="App">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Shop />
        <Boba />
        <Visit />
      </main>
      <Footer />
      <CartDrawer />
      <PaymentStatusWatcher />
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </CartProvider>
  );
}

export default App;
